export var WotcRoutes = {
    "jobWotc": {
        "url": "/wotc/{brand_id:[0-9]*}?job_id&app_id",
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            job_id: {dynamic: true},
            app_id: {dynamic: true},
        },
        "name": "job-post.wotc",
        "dynamic-template": "brand",
        "type": "frontend",
        "views": {
            "wotc-application": {
                "component": "wotcContainerComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wotc"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./wotc.module.js");
                }
            }
        ]
    },
    "/careerPortalJobWotc": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "url": "/wotc/{brand_id:[0-9]*}?job_id&app_id",
        "name": "employer.wotc",
        "dynamic-template": "brand",
        "params": {
            job_id: {dynamic: true},
            app_id: {dynamic: true},
        },
        "type": "frontend",
        "views": {
            "wotc-application": {
                "component": "wotcContainerComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["gp_career_portal"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./wotc.module.js");
                }
            }
        ]
    },
    "/wotc/{brand_id:[0-9]*}?app_id&prospect_id":{
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            app_id: {dynamic: true},
            prospect_id: {dynamic: true},
        },
        "name": "dashboard-member.wotc",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wotc"]
        },
        "views": {
            "wotc-application": {
                "component": "wotcContainerComponent",
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./wotc.module.js");
                }
            }
        ]
    },
    "/wotc/check/{brand_id:[0-9]*}?app_id&prospect_id&wotc_force": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "params": {
            app_id: {dynamic: true},
            prospect_id: {dynamic: true},
            wotc_force: {dynamic: true},
        },
        "name": "candidate_offer.wotc",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["wotc"]
        },
        "views": {
            "wotc-application": {
                "component": "wotcContainerComponent",
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./wotc.module.js");
                }
            }
        ]
    },
};

